import { useEffect, useRef, useState } from "react";
import { Speedometer } from "./Speedometer";

type SpeedometerData = {
  show: boolean;
  speedoType: number;
  maxSpeed: number;
  speed: number;
  acceleration: number;
  engine: boolean;
  fuel: number;
  seatBelt: boolean;
  doors: boolean;
};

export default function SpeedometerWrapper() {
  const [accelerating, setAccelerating] = useState(false);
  const [data, setData] = useState<SpeedometerData>({
    show: true,
    speedoType: 0,
    maxSpeed: 400,
    speed: 0,
    acceleration: 0.08,
    engine: true,
    fuel: 60,
    seatBelt: true,
    doors: false,
  });

  /* const speedRef = useRef(data.speed);
  const accelRef = useRef(data.acceleration);
  const shiftCooldownRef = useRef(0);

  useEffect(() => {
    const onDown = () => setAccelerating(true);
    const onUp = () => setAccelerating(false);

    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("keydown", onDown);
    window.addEventListener("keyup", onUp);

    return () => {
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("keydown", onDown);
      window.removeEventListener("keyup", onUp);
    };
  }, []);

  useEffect(() => {
    const tickMs = 50;

    const id = window.setInterval(() => {
      let speed = speedRef.current;
      let acceleration = accelRef.current;
      let shiftCooldown = shiftCooldownRef.current;

      const maxSpeed = 400;
      const minAcceleration = 0;
      const maxAcceleration = 1;

      if (shiftCooldown > 0) {
        shiftCooldown -= 1;
      }

      if (accelerating) {
        const accelStep =
          speed < 60
            ? 0.035
            : speed < 140
              ? 0.028
              : speed < 220
                ? 0.022
                : 0.016;

        acceleration += accelStep;

        if (acceleration > 0.92 && shiftCooldown === 0) {
          acceleration -= 0.33;
          shiftCooldown = 10;
        }

        acceleration = Math.min(maxAcceleration, acceleration);

        const speedGain = 1.5 + acceleration * 6 - speed / maxSpeed;

        speed = Math.min(maxSpeed, speed + Math.max(0.8, speedGain));
      } else {
        acceleration -= acceleration > 0.4 ? 0.035 : 0.02;
        acceleration = Math.max(minAcceleration, acceleration);

        const speedLoss = speed > 160 ? 2.2 : speed > 80 ? 1.6 : 1.0;

        speed = Math.max(0, speed - speedLoss);
      }

      if (speed < 5 && !accelerating) {
        acceleration = 0;
      }

      speedRef.current = speed;
      accelRef.current = acceleration;
      shiftCooldownRef.current = shiftCooldown;

      setData((prev) => ({
        ...prev,
        speed,
        acceleration,
      }));
    }, tickMs);

    return () => window.clearInterval(id);
  }, [accelerating]); */

  return (
    <Speedometer
      className="absolute bottom-5 right-10"
      {...data}
      liters={data.fuel}
      maxLiters={75}
      indicators={{
        seatbelt: data.seatBelt,
        doors: data.doors,
        airbag: true,
        handbrake: true,
      }}
      health={25}
      maxHealth={100}
      scale={0.7}
    />
  );
}
